import { AlertMessage } from '@/app/components'
import { Text } from '@/components'
import useShouldShowHomeEstimations from '../useShouldShowHomeEstimations'
import useHomeEstimationNavigation, {
  HomeEstimationPages,
} from '@/app/pages/home-estimations/useHomeEstimationNavigation'

type Props = {
  from: string
  hideAfterHomeEstimationSubmission: boolean
}

export default function HomeEstimationUpdateNotification(props: Props) {
  const shouldShowHomeEstimations = useShouldShowHomeEstimations()
  const homeEstimationNavigation = useHomeEstimationNavigation()

  const navigateToHomeEstimations = () => {
    homeEstimationNavigation.push(
      HomeEstimationPages.Home,
      undefined,
      `devices/thermostat/${props.from}`,
    )
  }

  if (!shouldShowHomeEstimations && props.hideAfterHomeEstimationSubmission) {
    return null
  }

  return (
    <AlertMessage variant="info" className="mt-2">
      <div className="mb-2">Want to improve accuracy of savings?</div>
      <Text variant="link" onClick={navigateToHomeEstimations}>
        Submit home details
      </Text>
    </AlertMessage>
  )
}
